/*@ngInject*/
const CollaborationDeleteTaskRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.deleteCollaborationTask = function (taskId) {
        let url = '/rest/SubmissionTask/' + taskId;

        return this.delete(url);
    };

    this.deleteCollaborationTaskAttachment = function (taskId, attachmentId) {
        var url = '/rest/SubmissionTask/' + taskId + '/Attachment',
            config = {
                params: {
                    attachmentId: attachmentId
                }
            };
        return this.delete(url, config);
    };
};

angular.module('gw-um-submission')
    .service('collaborationDeleteTaskRepository', CollaborationDeleteTaskRepository);
